import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../assets/scss/login-forms.scss";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";
import { saveUserAddress, signUpAsExternalUser } from "../sign-up/actions";
import { validateSignupEmail, validateSignupPassword } from "../../validators/genericValidator";
import PathHelper, { getLinkWithLocale, redirectToDashboardWithLocale } from "../../utils/path-helper";
import { getSignInLink } from "../../utils/path-helper";
import i18next from "i18next";
import { APP_NAVIGATION, AFFILIATE_SOURCE_VALUE, AFFILIATE_SOURCE_NAME, EMPTY_GUID } from "../../utils/constants";
import { getTenantId, currentDomain, getGoogleCaptchaKey, getTenantGroupId } from "../../utils/general-config";
import axios from "axios";
import {
  readCookie,
  createCookie,
  loadScript,
  removeScript,
  getIPConfig,
  isUserLoggedIn,
  UserDocMapping,
  getPortalCD,
  sendWelcomeEmail,
  PerquisiteBountyEnable,
  isAllAddressCookiePresent,
  checkQueryParams,
  isPricingPageFlow,
  buildPricingPageUrl,
} from "../../utils/helpers";
import CreateUUID from "../../utils/helpers";
import { trackEvents, trackEventsV2 } from "../../utils/tracking-events";
import { eventServicePost, loginAttempt, signUpUser, authUser, getAddress, getUserAbridged } from "./actions";
import { DomainEnum } from "../../services/enum/environment-enum";
import { getUserDocumentAttributes } from "../sign-in/actions";
import {
  getResumeBuildBaseURL,
  getPdfSimpliBaseURL,
  getSignSimpliBaseURL,
  getWorksimpliEndPoint,
} from "../../services/api-constants";
import ReactLoader from "../../components/resumebuild-loader/component";
import RBSignUp from "./rb";
import SignSimpliSignUp from "./ss";
import PdfSimpliSignUp from "./ps";
import LegalSimpliSignUp from "./ls";
import { addWelcomeDocument, ProcessSignInRequest, ProcessSignUpRequest } from "../../utils/document-helper";
import { ConductABTest } from "../../utils/abtest-helper";
import { jwtDecode } from "jwt-decode";
import userServiceApi from "../../services/user-service-api";
import PSRSignUP from "./PSReskining/psr.js";

const SignUp = ({ funnelStep }) => {
  // useDataTrack("register");
  const { locale } = useParams();
  let pathRedirect = PathHelper(APP_NAVIGATION.SINU);
  let signInLink = getSignInLink(locale, window.location.search);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState();
  const toggleLoader = (t) => setShowLoader(t);
  const [disableBtn, setdisableBtn] = useState(false);
  const [errorCount, setErrorCount] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const [showLoader, setShowLoader] = useState("d-none");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [termsOfUse, setTermsOfUse] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  let PathRedirectDashboard = PathHelper(APP_NAVIGATION.DASH);

  let privacyLinksOption = PathHelper(APP_NAVIGATION.PRVY, false);
  let termsAndConditionOption = PathHelper(APP_NAVIGATION.TUSE, false);
  let subDomainParam;
  if (queryParams.has("q")) {
    // NOTE :: This query param will let us know from which sub domain, user is getting redirect from.
    subDomainParam = queryParams.get("q");
  }
  let domain = currentDomain().toLowerCase();
  const isTargetDomain = [DomainEnum.PDFSIMPLI, DomainEnum.WORKSIMPLI, DomainEnum.SIGNSIMPLI].includes(domain);
  const setUrls = (policy, terms, contact) => {
    setPrivacyPolicy(policy);
    setTermsOfUse(terms);
  };
  useEffect(() => {
    setUrls(privacyLinksOption.cstm, termsAndConditionOption.cstm);
  }, []);
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        setLoginError(true);
        setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      setLoginError(true);
      setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const appleLogin = async ({ user, authorization }) => {
    try {
      const { id_token: idToken } = authorization;
      if (!idToken) {
        setLoginError(true);
        // setLoginErrorMessage("Authorization token not found.");
        return;
      }
      const decodedToken = jwtDecode(idToken);
      const email = user?.email || decodedToken?.email;
      const fullName =
        user?.name?.firstName && user?.name?.lastName ? `${user.name.firstName} ${user.name.lastName}` : "";
      const sub = decodedToken?.sub;
      responseApple({ ...decodedToken, fullName }, authorization?.code);
    } catch (error) {
      console.error("Error during Apple login:", error);
      setLoginError(true);
      setLoginErrorMessage(error.message || "Failed to log in with Apple.");
    }
  };

  useEffect(() => {
    if (getGoogleCaptchaKey() != "") {
      loadScript("https://www.google.com/recaptcha/api.js?render=" + getGoogleCaptchaKey());
      trackEvents("signUpView", {
        visitId: readCookie("visitGuid"),
        userGuid: "",
        portalSource: getPortalCD(locale),
        eventLabel: "signUp View",
        email: "",
        firstName: "",
        lastName: "",
      });

      return () => {
        removeScript("https://www.google.com/recaptcha/api.js?render=" + getGoogleCaptchaKey());
      };
    }
  }, []);

  const isSignSimpliUser = () => {
    let semlCookie = readCookie("seml");
    if (!!semlCookie && semlCookie !== null && semlCookie !== "") {
      let validEmail = decodeURIComponent(semlCookie);
      setEmail(validEmail);
    }
  };
  useEffect(() => {
    if (queryParams.has("evp")) {
      isSignSimpliUser();
    }
    let isLoggedIn = isUserLoggedIn();
    if (isLoggedIn) {
      setShowLoader("d-block");
      getUserAbridged().then((response) => {
        if (!!response) {
          let isGuestUser = response && response?.roleNames?.includes("guest") ? true : false;
          NavigationHandler(
            readCookie("userguid"),
            PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
            false,
            isGuestUser,
            isLoggedIn
          );
        } else {
          NavigationHandler(readCookie("userguid"), false);
        }
      });
    }
    if (!isAllAddressCookiePresent()) {
      getIPConfig();
    }
  }, []);

  const onEmailChangeHandler = (e) => {
    setEmailError(false);
    setPasswordError(false);
    const {
      target: { value },
    } = e;
    setEmail(value);
  };
  const onPwdChangeHandler = (e) => {
    setPasswordError(false);
    const {
      target: { value },
    } = e;
    setPwd(value);
  };
  const onPasswordKeyPress = (e) => {
    const { charCode } = e;
    if (charCode === 13) {
      onSignUp();
    }
  };
  const isAffilateUser = () => {
    return readCookie(AFFILIATE_SOURCE_NAME) == AFFILIATE_SOURCE_VALUE;
  };
  const signUpNextNavigate = () => {
    navigate("/app/account/home"); //TODO:
  };

  const onSignUp = () => {
    // toggleLoader(true);
    setShowLoader("d-block");
    setLoginError(false);
    const isValid = validateData();
    // IMPORTANT NOTE :: Domain Check will be there till we got the captha code for quic worx.
    // Once we got the google key/code for QW there will be not addition check for any domain..
    if (isValid) {
      window?.grecaptcha.ready(function () {
        window?.grecaptcha
          .execute(getGoogleCaptchaKey(), {
            action: "register",
          })
          .then(function (token) {
            const loginAttemptReq = {
              emailAddress: emailId.trim(),
              ipAddress: readCookie("ipAddress"),
              attemptType: "Registration",
              visitorId: readCookie("visitorGuid"),
              visitId: readCookie("visitGuid"),
              createdBy: readCookie("visitorGuid"),
              portalCD: getPortalCD(locale),
              greCaptchaToken: token,
              isCaptchaRequired: true,
            };
            loginAttempt(loginAttemptReq)
              .then((response) => {
                if (response != null && response?.Id != EMPTY_GUID && response.error == "") {
                  const params = {
                    email: emailId.trim(),
                    password: pwd.trim(),
                    portalCD: getPortalCD(locale),
                    tenantId: getTenantId(subDomainParam),
                    countryCD: readCookie("country"),
                    currencyCD: readCookie("currency"),
                    tenantGroupId: getTenantGroupId(),
                    designVersion: "reskin",
                  };

                  signUpUser(params)
                    .then((response) => {
                      if (!!response) {
                        let validUserGuid = response.userGuid;
                        if (response.isValid) {
                          const authData = {
                            Username: emailId.trim(),
                            UserGuid: response.userGuid,
                            Email: emailId.trim(),
                          };
                          authUser(authData, subDomainParam).then((authResponse) => {
                            if (!!authResponse) {
                              let data = {
                                Id: CreateUUID(),
                                UserId: response.userGuid,
                                VisitorId: readCookie("visitorGuid"),
                                VisitId: readCookie("visitGuid"),
                              };
                              ConductABTest(response, params.portalCD);
                              eventServicePost(data).then((eventServiceResponse) => {});
                              eventServicePost(data).then((eventServiceResponse) => {});
                              getAddress(response.userGuid).then((addResponse) => {
                                if (!!addResponse) {
                                  var addressReq = {
                                    UserGuid: response.userGuid,
                                    City: addResponse[0],
                                    State: addResponse[1],
                                    Country: addResponse[2],
                                    ZipCode: addResponse[3],
                                    AddressType: 0,
                                    IsActive: 1,
                                    TenantId: getTenantId(subDomainParam),
                                  };
                                  saveUserAddress(addressReq).then((addressResponse) => {
                                    if (!!addressResponse) {
                                      SignupSuccessEvent(response.userGuid, emailId.trim())
                                        .then(async (eventTrackResponse) => {
                                          // let queryId = queryParams.has("qid") ? queryParams.get("qid") : "";
                                          if (checkQueryParams(queryParams)) {
                                            setIsProcessing(true);

                                            ProcessSignUpRequest(queryParams, validUserGuid, false).then(
                                              async (processResponse) => {
                                                if (!!processResponse) {
                                                  //ToDo: No need to check domain here. It can be managed within single email function.
                                                  if (
                                                    currentDomain() === DomainEnum.PDFSIMPLI ||
                                                    currentDomain() === DomainEnum.WORKSIMPLI ||
                                                    currentDomain() === DomainEnum.SIGNSIMPLI
                                                  ) {
                                                    await sendWelcomeEmail(response.userGuid, locale);
                                                    if (currentDomain() === DomainEnum.SIGNSIMPLI) {
                                                      let userProfileResponse = await userServiceApi.getUserProfile(
                                                        response.userGuid
                                                      );
                                                      let documentProfile = userProfileResponse.documentProfile || [];
                                                      if (
                                                        documentProfile.length === 0 ||
                                                        !documentProfile.some((doc) => doc.isWelcomeDocument)
                                                      ) {
                                                        await addWelcomeDocument(response.userGuid);
                                                      }
                                                    }
                                                  }

                                                  console.log("Process response and navigate...");
                                                  NavigationHandler(validUserGuid, false);
                                                } else {
                                                  console.log("error at process response...");
                                                  setShowLoader("d-none");
                                                  NavigationHandler(validUserGuid, false);
                                                }
                                              }
                                            );
                                          } else {
                                            // Direct Sign up
                                            if (isTargetDomain) {
                                              await sendWelcomeEmail(response.userGuid, locale);
                                              if (domain !== DomainEnum.WORKSIMPLI) {
                                                await addWelcomeDocument(validUserGuid);
                                              }
                                            }
                                            console.log(" Direct Sign up");
                                            NavigationHandler(validUserGuid, false);
                                          }
                                        })
                                        .catch(() => {
                                          console.log(" Exception Sign up");
                                          NavigationHandler(validUserGuid);
                                        });
                                    } else {
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      // logging
                                    }
                                  });
                                } else {
                                  setShowLoader("d-none");
                                  setdisableBtn(false);
                                  setLoginError(true);
                                  setLoginErrorMessage(t("generic_error.inaction_message"));
                                }
                              });
                            } else {
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                            }
                          });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setPwd("");
                          setLoginErrorMessage(
                            domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                              ? t("sign_up.email_already_taken")
                              : t("sign_up.user_exists")
                          );
                        }
                      } else {
                        console.log("Invalid Response.");
                      }
                    })
                    .catch((error) => {
                      setShowLoader("d-none");
                      // toggleLoader(false);
                      setLoginError(true);
                      setLoginErrorMessage(error.message);
                      console.log(error);
                    });
                } else {
                  if (!!response && response.statusCode === 412) {
                    setLoginErrorMessage(t("generic_error.Suspicious_Signup"));
                    setShowLoader("d-none");
                    setLoginError(true);
                    setdisableBtn(false);
                  } else {
                    setPwd("");
                    setLoginErrorMessage(t("generic_error.max_Signup_attempt"));
                    setShowLoader("d-none");
                    setLoginError(true);
                    setdisableBtn(false);
                  }
                }
              })
              .catch((error) => {
                // toggleLoader(false);
                setPwd("");
                setLoginErrorMessage(t("generic_error.inaction_message"));
                setShowLoader("d-none");
                setLoginError(true);
                setdisableBtn(false);
              });
          });
      });
    } else {
      // toggleLoader(false);
      setShowLoader("d-none");
      setdisableBtn(false);
    }
  };

  const SignupSuccessEvent = (userGuid, email) => {
    return trackEventsV2("signUpSuccess", {
      visitId: readCookie("visitGuid"),
      userGuid: userGuid,
      portalSource: getPortalCD(locale),
      eventLabel: "signUp Success",
      email: email,
      firstName: "",
      lastName: "",
    });
  };
  const responseFacebook = (response) => {
    if (!!response && response.status != "unknown") {
      setShowLoader("d-block");
      setEmailError(false);
      const { name, email, id } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            currencyCD: readCookie("currency"),
            portalCD: getPortalCD(locale),
            parentUserGuid: "",
            firstName: name,
            lastName: "",
            company: "",
            title: "",
            email: email, //email
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 1,
            providerKey: id, // "100732998798818",
          },
        };
        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
              createCookie("userguid", response.userGuid, 1);
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              authUser(authData, subDomainParam).then((authResponse) => {
                if (!!authResponse) {
                  let data = {
                    Id: CreateUUID(),
                    UserId: response.userGuid,
                    VisitorId: readCookie("visitorGuid"),
                    VisitId: readCookie("visitGuid"),
                  };
                  eventServicePost(data).then((eventServiceResponse) => {});
                  if (response.isSocialUserExists === true) {
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then((eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                    (processResponse) => {
                                      if (!!processResponse) {
                                        console.log("Process response and navigate...");
                                        if (!!isPerquisiteBountyEnable) {
                                          NavigationHandler(
                                            response.userGuid,
                                            isPerquisiteBountyEnable,
                                            response.isSocialUserExists
                                          );
                                        } else {
                                          NavigationHandler(response.userGuid);
                                        }
                                      } else {
                                        console.log("error at process response...");
                                        setShowLoader("d-none");
                                        setdisableBtn(false);
                                        setLoginError(true);
                                        setLoginErrorMessage(t("generic_error.inaction_message"));
                                        NavigationHandler(response.userGuid);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  if (!!isPerquisiteBountyEnable) {
                                    NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                  } else {
                                    NavigationHandler(response.userGuid);
                                  }
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            //if response part of saveuseraddress api
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        }); //saveuseraddress api
                      } else {
                        //if response part of getaddress api
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } else {
                    ConductABTest(response, externalData.createUser.portalCD);
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then(async (eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                    async (processResponse) => {
                                      if (!!processResponse) {
                                        //ToDo: No need to check domain here. It can be managed within single email function.
                                        if (
                                          currentDomain() === DomainEnum.PDFSIMPLI ||
                                          currentDomain() === DomainEnum.WORKSIMPLI ||
                                          currentDomain() === DomainEnum.SIGNSIMPLI
                                        ) {
                                          await sendWelcomeEmail(response.userGuid, locale);
                                        }
                                        console.log("Process response and navigate...");
                                        NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                      } else {
                                        console.log("error at process response...");
                                        NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  //ToDo: No need to check domain here. It can be managed within single email function.
                                  if (isTargetDomain) {
                                    await sendWelcomeEmail(response.userGuid, locale);
                                    if (domain !== DomainEnum.WORKSIMPLI) {
                                      await addWelcomeDocument(response.userGuid);
                                    }
                                  }

                                  console.log(" Direct Sign up");
                                  NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        });
                      } else {
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } //else part of isSocialUserExists flag
                } else {
                  setShowLoader("d-none");
                  setdisableBtn(false);
                  setLoginError(true);
                  setLoginErrorMessage(t("generic_error.inaction_message"));
                }
              });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setPwd("");
              setLoginErrorMessage(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                  ? t("sign_up.email_already_taken")
                  : t("sign_up.user_exists")
              );
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setLoginErrorMessage(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.RESUMEBUILD || domain === DomainEnum.SIGNSIMPLI
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert")
              );
            }
          });
      } else {
        setShowLoader("d-none");
        setLoginErrorMessage(t("sign_up.facebook_invalid"));
        setLoginError(true);
      }
    }
  };

  const responseGoogle = (response, accessToken) => {
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setEmailError(false);

      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: readCookie("country"),
          currencyCD: readCookie("currency"),
          portalCD: getPortalCD(locale),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(subDomainParam),
          tenantGroupId: getTenantGroupId(),
          designVersion: "reskin",
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id,
        },
      };
      signUpAsExternalUser(externalData)
        .then((response) => {
          if (!!response) {
            let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
            createCookie("userguid", response.userGuid, 1);
            const authData = {
              Username: email.trim(),
              UserGuid: response.userGuid,
              Email: email.trim(),
            };
            authUser(authData, subDomainParam).then((authResponse) => {
              if (!!authResponse) {
                let data = {
                  Id: CreateUUID(),
                  UserId: response.userGuid,
                  VisitorId: readCookie("visitorGuid"),
                  VisitId: readCookie("visitGuid"),
                };

                eventServicePost(data).then((eventServiceResponse) => {});
                eventServicePost(data).then((eventServiceResponse) => {});
                if (response.isSocialUserExists === true) {
                  getAddress(response.userGuid).then((addResponse) => {
                    if (!!addResponse) {
                      var addressReq = {
                        UserGuid: response.userGuid,
                        City: addResponse[0],
                        State: addResponse[1],
                        Country: addResponse[2],
                        ZipCode: addResponse[3],
                        AddressType: 0,
                        IsActive: 1,
                        TenantId: getTenantId(subDomainParam),
                      };
                      saveUserAddress(addressReq).then((addressResponse) => {
                        if (!!addressResponse) {
                          SignupSuccessEvent(response.userGuid, email.trim())
                            .then((eventTrackResponse) => {
                              if (checkQueryParams(queryParams)) {
                                setIsProcessing(true);
                                ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                  (processResponse) => {
                                    if (!!processResponse) {
                                      console.log("Process response and navigate...");
                                      if (!!isPerquisiteBountyEnable) {
                                        NavigationHandler(
                                          response.userGuid,
                                          isPerquisiteBountyEnable,
                                          response.isSocialUserExists
                                        );
                                      } else {
                                        NavigationHandler(response.userGuid);
                                      }
                                    } else {
                                      console.log("error at process response...");
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      NavigationHandler(response.userGuid);
                                    }
                                  }
                                );
                              } else {
                                // Direct Sign up
                                if (!!isPerquisiteBountyEnable) {
                                  NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                } else {
                                  NavigationHandler(response.userGuid);
                                }
                              }
                            })
                            .catch(() => {
                              console.log(" Exception Sign up");
                              NavigationHandler(response.userGuid);
                            });
                        } else {
                          //if response part of saveuseraddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                          // logging
                        }
                      }); //saveuseraddress api
                    } else {
                      //if response part of getaddress api
                      setShowLoader("d-none");
                      setdisableBtn(false);
                      setLoginError(true);
                      setLoginErrorMessage(t("generic_error.inaction_message"));
                    }
                  });
                  //get address api
                } else {
                  ConductABTest(response, externalData.createUser.portalCD);
                  getAddress(response.userGuid).then((addResponse) => {
                    if (!!addResponse) {
                      var addressReq = {
                        UserGuid: response.userGuid,
                        City: addResponse[0],
                        State: addResponse[1],
                        Country: addResponse[2],
                        ZipCode: addResponse[3],
                        AddressType: 0,
                        IsActive: 1,
                        TenantId: getTenantId(subDomainParam),
                      };
                      saveUserAddress(addressReq).then((addressResponse) => {
                        if (!!addressResponse) {
                          SignupSuccessEvent(response.userGuid, email.trim())
                            .then(async (eventTrackResponse) => {
                              if (checkQueryParams(queryParams)) {
                                setIsProcessing(true);
                                ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                  async (processResponse) => {
                                    if (!!processResponse) {
                                      if (
                                        currentDomain() === DomainEnum.PDFSIMPLI ||
                                        currentDomain() === DomainEnum.WORKSIMPLI ||
                                        currentDomain() === DomainEnum.SIGNSIMPLI
                                      ) {
                                        await sendWelcomeEmail(response.userGuid, locale);
                                      }
                                      console.log("Process response and navigate...");
                                      NavigationHandler(response.userGuid, false);
                                    } else {
                                      console.log("error at process response...");
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      NavigationHandler(response.userGuid);
                                    }
                                  }
                                );
                              } else {
                                if (isTargetDomain) {
                                  await sendWelcomeEmail(response.userGuid, locale);
                                  if (domain !== DomainEnum.WORKSIMPLI) {
                                    await addWelcomeDocument(response.userGuid);
                                  }
                                }
                                // Direct Sign up
                                console.log(" Direct Sign up");
                                NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                              }
                            })
                            .catch(() => {
                              console.log(" Exception Sign up");
                              NavigationHandler(response.userGuid);
                            });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                          // logging
                        }
                      });
                    } else {
                      setShowLoader("d-none");
                      setdisableBtn(false);
                      setLoginError(true);
                      setLoginErrorMessage(t("generic_error.inaction_message"));
                    }
                  });
                  //get address api
                } //else part of isSocialUserExists flag
              } else {
                //if response part of authUser api
                setShowLoader("d-none");
                setdisableBtn(false);
                setLoginError(true);
                setLoginErrorMessage(t("generic_error.inaction_message"));
              }
            }); //authuser api
          } else {
            //if response part of signUpAsExternalUser api
            setShowLoader("d-none");
            // toggleLoader(false);
            setdisableBtn(false);
            setLoginError(true);
            setPwd("");
            setLoginErrorMessage(
              domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                ? t("sign_up.email_already_taken")
                : t("sign_up.user_exists")
            );
          }
        })
        .catch((error) => {
          // signUpAsExternalUser api then part
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          if (error.response?.data?.isAccountLocked) {
            setPasswordError(true);
            setLoginErrorMessage(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI || domain === DomainEnum.RESUMEBUILD
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert")
            );
          }
        });
    } else {
      //very outside else first else
      setShowLoader("d-none");
      setLoginErrorMessage(t("sign_up.facebook_invalid"));
      setLoginError(true);
    }
  };

  const responseApple = (response, code) => {
    if (!!response && !!code) {
      setShowLoader("d-block");
      setEmailError(false);
      const { email, fullName, sub } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            currencyCD: readCookie("currency"),
            portalCD: getPortalCD(locale),
            parentUserGuid: "",
            firstName: fullName,
            lastName: "",
            company: "",
            title: "",
            email: email,
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 4,
            providerKey: sub,
          },
        };
        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
              createCookie("userguid", response.userGuid, 1);
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              authUser(authData, subDomainParam).then((authResponse) => {
                if (!!authResponse) {
                  let data = {
                    Id: CreateUUID(),
                    UserId: response.userGuid,
                    VisitorId: readCookie("visitorGuid"),
                    VisitId: readCookie("visitGuid"),
                  };
                  eventServicePost(data).then((eventServiceResponse) => {});
                  if (response.isSocialUserExists === true) {
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then((eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                    (processResponse) => {
                                      if (!!processResponse) {
                                        console.log("Process response and navigate...");
                                        if (!!isPerquisiteBountyEnable) {
                                          NavigationHandler(
                                            response.userGuid,
                                            isPerquisiteBountyEnable,
                                            response.isSocialUserExists
                                          );
                                        } else {
                                          NavigationHandler(response.userGuid);
                                        }
                                      } else {
                                        console.log("error at process response...");
                                        setShowLoader("d-none");
                                        setdisableBtn(false);
                                        setLoginError(true);
                                        setLoginErrorMessage(t("generic_error.inaction_message"));
                                        NavigationHandler(response.userGuid);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  if (!!isPerquisiteBountyEnable) {
                                    NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                  } else {
                                    NavigationHandler(response.userGuid);
                                  }
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            //if response part of saveuseraddress api
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        }); //saveuseraddress api
                      } else {
                        //if response part of getaddress api
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } else {
                    ConductABTest(response, externalData.createUser.portalCD);
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then(async (eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                    async (processResponse) => {
                                      if (!!processResponse) {
                                        if (
                                          currentDomain() === DomainEnum.PDFSIMPLI ||
                                          currentDomain() === DomainEnum.WORKSIMPLI ||
                                          currentDomain() === DomainEnum.SIGNSIMPLI
                                        ) {
                                          await sendWelcomeEmail(response.userGuid, locale);
                                        }
                                        console.log("Process response and navigate...");
                                        NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                      } else {
                                        console.log("error at process response...");
                                        NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  if (isTargetDomain) {
                                    await sendWelcomeEmail(response.userGuid, locale);
                                    if (domain !== DomainEnum.WORKSIMPLI) {
                                      await addWelcomeDocument(response.userGuid);
                                    }
                                  }
                                  console.log(" Direct Sign up");
                                  NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        });
                      } else {
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } //else part of isSocialUserExists flag
                } else {
                  setShowLoader("d-none");
                  setdisableBtn(false);
                  setLoginError(true);
                  setLoginErrorMessage(t("generic_error.inaction_message"));
                }
              });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setPwd("");
              setLoginErrorMessage(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                  ? t("sign_up.email_already_taken")
                  : t("sign_up.user_exists")
              );
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setLoginErrorMessage(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI || domain === DomainEnum.RESUMEBUILD
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert")
              );
            }
          });
      } else {
        setShowLoader("d-none");
        setLoginErrorMessage(t("sign_up.apple_invalid"));
        setLoginError(true);
      }
    }
  };

  const NavigationHandler = (
    validUserGuid,
    isPerquisiteBountyEnable,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser
  ) => {
    console.log("inside NavigationHandler ");
    let docid = "";
    let type = "";
    if (queryParams.has("docid")) {
      docid = queryParams.get("docid");
    }
    if (queryParams.has("type")) {
      type = queryParams.get("type");
    } else if (queryParams.has("doctype")) {
      // doctype comes from WP sign in page, later will be doctype and type will be removed to be in sync.
      type = queryParams.get("doctype");
    }

    if (currentDomain() === DomainEnum.RESUMEBUILD) {
      // If no doc created then direct redirect to create resume page
      // else Create the mapping first and then redirect to review page
      if (!!docid) {
        UserDocMapping(docid, validUserGuid).then((mappingResponse) => {
          if (!!docid) {
            getUserDocumentAttributes(validUserGuid, 10)
              .then((abridgedResponse) => {
                NavigationHandlerForRB(locale, docid, type, abridgedResponse.docCount);
              })
              .catch((error) => {
                NavigationHandlerForRB(locale, docid, type, 0);
              });
          } else {
            NavigationHandlerForRB(locale, docid, type, 0);
          }
        });
      } else {
        NavigationHandlerForRB(locale, docid, type, 0);
      }
    } else if (currentDomain() === DomainEnum.PDFSIMPLI) {
      NavigationHandlerForPDFsimpli(
        locale,
        "",
        "",
        0,
        isPerquisiteBountyEnable,
        isSocialUserExists,
        isGuestUser,
        isLoggedInUser
      );
    } else if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      NavigationHandlerForSignSimpli(locale, "", "", 0, isPerquisiteBountyEnable, isSocialUserExists, isGuestUser);
    } else if (currentDomain() === DomainEnum.WORKSIMPLI) {
      NavigationHandlerForWorkSimpli(locale, isPerquisiteBountyEnable, isSocialUserExists, isGuestUser);
    }
    // NOTE ::: If local env then redirect on home page else on dashboard.
    else if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
      navigate(pathRedirect.cstm);
    } else {
      redirectToDashboardWithLocale(locale);
    }
  };

  const NavigationHandlerForRB = (locale, docGuid, type, numberOfDocs) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.RESUMEBUILD) {
      urlPrefix = getPdfSimpliBaseURL;
      if (isPricingPageFlow()) {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
        window.location.assign(urlPost);
      } else {
        urlPrefix = getResumeBuildBaseURL;
        if (!!type && type?.toLowerCase() === "cvlt") {
          if (!!docGuid) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docGuid;
          } else if (numberOfDocs > 0) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letters");
          } else {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-introduction");
          }
        } else {
          if (!!docGuid) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review") + "?docid=" + docGuid;
          } else if (numberOfDocs > 0) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
          } else {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction");
          }
        }
        console.log("NavigationHandlerForRB", urlPost);
        window.location.assign(urlPost);
      }
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
        navigate(pathRedirect.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };

  const NavigationHandlerForPDFsimpli = (
    locale,
    docId,
    type,
    numberOfDocs,
    isPerquisiteBountyEnable = false,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser
  ) => {
    let urlPrefix = "";
    let urlPost = "";
    const validUserGuid = readCookie("userguid");
    if (currentDomain() === DomainEnum.PDFSIMPLI) {
      urlPrefix = getPdfSimpliBaseURL;
      console.log("inside NavigationHandlerForPDFsimpli", isPricingPageFlow());
      if (isPricingPageFlow()) {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
        window.location.assign(urlPost);
      } else if (isPerquisiteBountyEnable === false && !isGuestUser && !isLoggedInUser) {
        console.log("Non paid user..");
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
        window.location.assign(urlPost);
      } else if (!!type && type.toLowerCase() === "cvlt") {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
        window.location.assign(urlPost);
      } else {
        if (!!docId) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
          window.location.assign(urlPost);
        } else if (numberOfDocs > 0) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
          window.location.assign(urlPost);
        } else {
          if (isSocialUserExists === true) {
            if (isPricingPageFlow()) {
              urlPrefix = getPdfSimpliBaseURL;
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
              window.location.assign(urlPost);
            } else if (isLoggedInUser) {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
            } else {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
            }
            console.log("NavigationHandlerForPDFsimpli", urlPost);
            window.location.assign(urlPost);
          } else {
            if (
              (!!validUserGuid && window.location.search !== "" && queryParams.has("ofn")) ||
              queryParams.has("evp")
            ) {
              setIsProcessing(true);
              ProcessSignInRequest(
                queryParams,
                validUserGuid,
                isPerquisiteBountyEnable,
                false,
                isGuestUser,
                locale,
                isLoggedInUser
              ).then((processResponse) => {
                if (!!processResponse) {
                  if (isPricingPageFlow()) {
                    urlPrefix = getPdfSimpliBaseURL;
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                    window.location.assign(urlPost);
                  } else if (isLoggedInUser) {
                    if (isPerquisiteBountyEnable || isGuestUser) {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                    } else {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                    }
                  } else {
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                  }
                } else {
                  if (isPricingPageFlow()) {
                    urlPrefix = getPdfSimpliBaseURL;
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                    window.location.assign(urlPost);
                  } else if (isLoggedInUser) {
                    if (isPerquisiteBountyEnable || isGuestUser) {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                    } else {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                    }
                  } else {
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                  }
                }
                console.log("NavigationHandlerForPDFSimpliSuccess", urlPost);
                window.location.assign(urlPost);
              });
            } else {
              console.log("NavigationHandlerForPDFSimpli", urlPost);
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              window.location.assign(urlPost);
            }
          }
        }
      }
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` === "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };
  const NavigationHandlerForWorkSimpli = (
    locale,
    isPerquisiteBountyEnable = false,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser
  ) => {
    let urlPrefix = "";
    let urlPost = "";
    const validUserGuid = readCookie("userguid");
    urlPrefix = getWorksimpliEndPoint;
    if (isPricingPageFlow()) {
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
      window.location.assign(urlPost);
    } else if (isPerquisiteBountyEnable === false && !isGuestUser && !isLoggedInUser) {
      console.log("Non paid user..");
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
      window.location.assign(urlPost);
    } else {
      if (isSocialUserExists === true) {
        if (isPricingPageFlow()) {
          urlPrefix = getPdfSimpliBaseURL;
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
          window.location.assign(urlPost);
        } else if (isLoggedInUser) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
        }
        window.location.assign(urlPost);
      } else {
        if ((!!validUserGuid && window.location.search !== "" && queryParams.has("ofn")) || queryParams.has("evp")) {
          setIsProcessing(true);
          ProcessSignInRequest(
            queryParams,
            validUserGuid,
            isPerquisiteBountyEnable,
            false,
            isGuestUser,
            locale,
            isLoggedInUser
          ).then((processResponse) => {
            if (!!processResponse) {
              if (isPricingPageFlow()) {
                urlPrefix = getPdfSimpliBaseURL;
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                window.location.assign(urlPost);
              } else if (isLoggedInUser) {
                if (isPerquisiteBountyEnable || isGuestUser) {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                } else {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                }
              } else {
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              }
            } else {
              if (isPricingPageFlow()) {
                urlPrefix = getPdfSimpliBaseURL;
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                window.location.assign(urlPost);
              } else if (isLoggedInUser) {
                if (isPerquisiteBountyEnable || isGuestUser) {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                } else {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                }
              } else {
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              }
            }
            window.location.assign(urlPost);
          });
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
          window.location.assign(urlPost);
        }
      }
    }
  };

  const NavigationHandlerForSignSimpli = (
    locale,
    docId,
    type,
    numberOfDocs,
    isPerquisiteBountyEnable = false,
    isSocialUserExists,
    isGuestUser
  ) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      urlPrefix = getSignSimpliBaseURL;
      if (isPerquisiteBountyEnable === false && !isGuestUser) {
        console.log("Non paid user..");
        urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "billing/plans");
        window.location.assign(urlPost);
      } //else if (!!type && type.toLowerCase() === "cvlt") {
      //   urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
      //   window.location.assign(urlPost);
      // }
      else {
        if (!!docId) {
          urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
          window.location.assign(urlPost);
        }
        // else if (numberOfDocs > 0) {
        //   urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
        //   window.location.assign(urlPost);
        // }
        else {
          const validUserGuid = readCookie("userguid");
          if (isSocialUserExists === true) {
            urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
            console.log("NavigationHandlerForSignsimpli", urlPost);
            window.location.assign(urlPost);
          } else {
            if (
              (!!validUserGuid && window.location.search !== "" && queryParams.has("ofn")) ||
              queryParams.has("evp")
            ) {
              setIsProcessing(true);
              ProcessSignInRequest(queryParams, validUserGuid, isPerquisiteBountyEnable, false, isGuestUser).then(
                (processResponse) => {
                  if (!!processResponse) {
                    urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
                  } else {
                    urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
                  }
                  console.log("NavigationHandlerForSignSimpliSuccess", urlPost);
                  window.location.assign(urlPost);
                }
              );
            } else {
              urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
              console.log("NavigationHandlerForSignSimpli", urlPost);
              window.location.assign(urlPost);
            }
          }
        }
      }
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` === "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };

  // const gigWorkersSignUpUserEvent = (userGuid, emailId) => {
  //   const eventData = {
  //     froUserGuid: userGuid,
  //     userGuid: userGuid,
  //     content: "DSBD",
  //     templateId: GigWorkerUserSignUpEvent.TemplateId,
  //     emailProvider: GigWorkerUserSignUpEvent.EmailProvider,
  //     emailMetaData: {
  //       portal: "ResumeBuild",
  //       PortalCD: getPortalCD(locale),
  //       currenturl: GigWorkersWelcomeEmailLink,
  //       toEmail: emailId.trim(),
  //       sendername: emailId.trim(),
  //       emailsubject: GigWorkersWelcomeEmailSubject,
  //       disablebcc: true,
  //     },
  //     envelopeId: "00000000-0000-0000-0000-000000000000",
  //     isAttachment: false,
  //     tenantId: getTenantId(),
  //   };
  //   const scheduleUtcTime = moment.utc().add(GigWorkersWelcomeEmailDelayMinutes, "m").toDate();
  //   postDataToEventServiceSchedule(
  //     eventData,
  //     GigWorkerUserSignUpEvent.EventType,
  //     GigWorkerUserSignUpEvent.EventSubType,
  //     GigWorkerUserSignUpEvent.TopicName,
  //     scheduleUtcTime
  //   ).then((response) => {});
  // };

  const validateData = () => {
    setEmailError(false);
    setPasswordError(false);
    let errors = 0;

    let emailValidator = validateSignupEmail(emailId.trim());
    if (emailValidator.isValid === false) {
      ++errors;
      setEmailError(true);
      if (domain === DomainEnum.RESUMEBUILD) {
        setEmailErrorMsg(emailValidator.errorMessage);
      } else {
        setEmailErrorMsg(`${i18next.t("sign_in.wrong_email_format_message")}`);
      }
      setErrorCount(errors);
      setShowLoader("d-none");
    }
    let passwordValidator = validateSignupPassword(pwd.trim(), emailId.trim());
    if (passwordValidator.isValid === false) {
      ++errors;
      if (
        domain === DomainEnum.PDFSIMPLI ||
        domain === DomainEnum.RESUMEBUILD ||
        domain === DomainEnum.SIGNSIMPLI ||
        domain === DomainEnum.WORKSIMPLI
      ) {
        if (pwd.length === 0 || emailId.length === 0) {
          setPasswordErrorMsg(passwordValidator.errorMessage);
          setPasswordError(true);
        } else {
          setPasswordErrorMsg(t("generic_error.password_char_long"));
          setPasswordError(true);
        }
      } else {
        setPasswordErrorMsg(passwordValidator.errorMessage);
      }
    }
    setErrorCount(errors);
    if (errors > 0) {
      ++errors;
      setdisableBtn(false);
      return false;
    } else {
      setdisableBtn(true);
      return true;
    }
  };
  const navigateSignIn = () => {
    navigate(signInLink);
  };
  return (
    <>
      <Header />
      <ReactLoader showloader={showLoader} isProcessing={isProcessing} />
      {/* <Loader showLoader={showLoader} toggleLoader={toggleLoader} /> */}

      {(() => {
        //const domain = currentDomain().toLowerCase();
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <PSRSignUP
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
                appleLogin={appleLogin}
              />
            );
          case DomainEnum.WORKSIMPLI:
            return (
              <PSRSignUP
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
                appleLogin={appleLogin}
              />
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <LegalSimpliSignUp
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
              />
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <SignSimpliSignUp
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
                appleLogin={appleLogin}
              />
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <RBSignUp
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
              />
            );
        }
      })()}
      {domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.WORKSIMPLI || domain === DomainEnum.SIGNSIMPLI ? (
        ""
      ) : (
        <Footer />
      )}
    </>
  );
};

export default SignUp;
